import CategoryList from "../../components/agency/CategoryList";
import DocumentsList from "../../components/agency/DocumentsList";

export const listAgencyTabs = (listCategories: any[], listDocuments: any[], idAzienda: any) => ({
    Categorie: [
        {
            id: 0,
            component: <CategoryList listCategories={listCategories} idAzienda={idAzienda} />
        },
    ],

    Documenti: [
        {
            id: 1,
            component: <DocumentsList listDocuments={listDocuments} listCategories={listCategories} idAzienda={idAzienda} />
        },
    ]
});